import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ProxyInfo, WebsocketConnection } from "../common.browser/Exports";
import { OutputFormat, PropertyId } from "../sdk/Exports";
import { ConnectionFactoryBase } from "./ConnectionFactoryBase";
import { WebsocketMessageFormatter } from "./Exports";
import { QueryParameterNames } from "./QueryParameterNames";
var baseUrl = "convai.speech.microsoft.com";
var botFramework = {
  authHeader: "X-DLS-Secret",
  resourcePath: "",
  version: "v3"
};
var customCommands = {
  authHeader: "X-CommandsAppId",
  resourcePath: "commands",
  version: "v1"
};
var pathSuffix = "api";

function getDialogSpecificValues(dialogType) {
  switch (dialogType) {
    case "custom_commands":
      {
        return customCommands;
      }

    case "bot_framework":
      {
        return botFramework;
      }
  }

  throw new Error("Invalid dialog type '".concat(dialogType, "'"));
}

export var DialogConnectionFactory = /*#__PURE__*/function (_ConnectionFactoryBas) {
  _inherits(DialogConnectionFactory, _ConnectionFactoryBas);

  function DialogConnectionFactory() {
    var _this;

    _classCallCheck(this, DialogConnectionFactory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DialogConnectionFactory).apply(this, arguments));

    _this.create = function (config, authInfo, connectionId) {
      var applicationId = config.parameters.getProperty(PropertyId.Conversation_ApplicationId, "");
      var dialogType = config.parameters.getProperty(PropertyId.Conversation_DialogType);
      var region = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Region);
      var language = config.parameters.getProperty(PropertyId.SpeechServiceConnection_RecoLanguage, "en-US");
      var queryParams = {};
      queryParams[QueryParameterNames.LanguageParamName] = language;
      queryParams[QueryParameterNames.FormatParamName] = config.parameters.getProperty(PropertyId.SpeechServiceResponse_OutputFormatOption, OutputFormat[OutputFormat.Simple]).toLowerCase();

      var _getDialogSpecificVal = getDialogSpecificValues(dialogType),
          resourcePath = _getDialogSpecificVal.resourcePath,
          version = _getDialogSpecificVal.version,
          authHeader = _getDialogSpecificVal.authHeader;

      var headers = {};
      headers[authInfo.headerName] = authInfo.token;
      headers[QueryParameterNames.ConnectionIdHeader] = connectionId;
      var endpoint; // ApplicationId is only required for CustomCommands

      if (applicationId === "") {
        endpoint = "wss://".concat(region, ".").concat(baseUrl, "/").concat(pathSuffix, "/").concat(version);
      } else {
        endpoint = "wss://".concat(region, ".").concat(baseUrl, "/").concat(resourcePath, "/").concat(pathSuffix, "/").concat(version);
        headers[authHeader] = applicationId;
      }

      _this.setCommonUrlParams(config, queryParams, endpoint);

      return new WebsocketConnection(endpoint, queryParams, headers, new WebsocketMessageFormatter(), ProxyInfo.fromRecognizerConfig(config), connectionId);
    };

    return _this;
  }

  return DialogConnectionFactory;
}(ConnectionFactoryBase);